import type { CauserSubjectProps } from "./causer-subject.type";

import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { getCauserSubjectRoute } from "./causer-subject.helper";

const { Text } = Typography;

export const CauserSubject = ({ type, model, item }: CauserSubjectProps) => {
  const { t } = useTranslation();

  if (!item) {
    if (type === "subject") return null;
    return <Text>{t("global:defaultCauserName")}</Text>;
  }

  const route = getCauserSubjectRoute(model, item);

  if (!route) return <Text>{item.name}</Text>;

  return <Link to={route}>{item.name}</Link>;
};
